import React from 'react';
import ReactGa from 'react-ga';

// import components
import Header from './components/Header';
import Hero from './components/Hero';
import Brands from './components/Brands';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BackTopBtn from './components/BackTopBtn';
import Particle from './components/Particle';
import Stack from './components/Stack';
import { useEffect } from 'react';


const App = () => {
  useEffect(() => {
    ReactGa.initialize('UA-209194656-1')

    ReactGa.pageview('/')
  }, [])
  return (
    <>
    <Particle />
    <div className=' relative'>
      <Header />
      <Hero />
      <About />
      <Stack />
      <Brands />
      <Portfolio />
      <Services />
      <Contact />
      <Footer />
      <BackTopBtn />
    </div>
    </>
  );
};

export default App;
